import { db } from '@/main'

export default {
  methods: {
    remove( collection, target, type ) {
      let ref = db.collection( collection ).doc( target.id )
      let msg = `Are you sure you want to delete ${type}: "${target.title}"?`
      if ( confirm( msg ) ) ref.delete().then( () =>
        this.items = this.items.filter( item => item.id != target.id )
      )
    },

    set( collection, target, next ) {
      console.log('set', next)
      db.collection( collection ).doc( target.id ).set( target, { merge: true } ).then( next )
    },

    add( collection, target, next ) {
      db.collection( collection ).add( target ).then( next )
    },

    get( collection, target ) {

    },

    collect( collection ) {
      db.collection( this.collection ).get().then
    },

    update( collection, target ) {
      db.collection( collection ).doc( target.id ).update( target )
    },
  }
}